/**
 * HTTP MIME type constants and utilities
 */
export const AUDIO_MP3_MIME = 'audio/mp3';
/**
 * HTTP MIME type constants and utilities
 */
export const AUDIO_MPEG_MIME = 'audio/mpeg';
/**
 * HTTP MIME type constants and utilities
 */
export const AUDIO_X_M4A_MIME = 'audio/x-m4a';
/**
 * HTTP MIME type constants and utilities
 */
export const COMPRESSED_MIME = 'application/octet-stream';
/**
 * HTTP MIME type constants and utilities
 */
export const JSON_MIME = 'application/json';
/**
 * HTTP MIME type constants and utilities
 */
export const MS_EXCEL_MIME = 'application/vnd.ms-excel';
/**
 * HTTP MIME type constants and utilities
 */
export const MS_POWERPOINT_MIME = 'application/vnd.ms-powerpoint';
/**
 * HTTP MIME type constants and utilities
 */
export const MS_WORD_MIME = 'application/msword';
/**
 * HTTP MIME type constants and utilities
 */
export const MS_XML_EXCEL_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
/**
 * HTTP MIME type constants and utilities
 */
export const MS_XML_POWERPOINT_MIME = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
/**
 * HTTP MIME type constants and utilities
 */
export const MS_XML_WORD_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
/**
 * HTTP MIME type constants and utilities
 */
export const MULTIPART_FORM_DATA_MIME = 'multipart/form-data';
/**
 * HTTP MIME type constants and utilities
 */
export const PDF_MIME = 'application/pdf';
/**
 * HTTP MIME type constants and utilities
 */
export const RAR_MIME = 'application/x-rar-compressed';
/**
 * HTTP MIME type constants and utilities
 */
export const RTF_MIME = 'application/rtf';
/**
 * HTTP MIME type constants and utilities
 */
export const URLENCODED_MIME = 'application/x-www-form-urlencoded';
/**
 * HTTP MIME type constants and utilities
 */
export const ZIP_MIME = 'application/zip';
/**
 * HTTP MIME type constants and utilities
 */
export const IMAGE_PNG_MIME = 'image/png';
/**
 * HTTP MIME type constants and utilities
 */
export const IMAGE_JPEG_MIME = 'image/jpeg';
/**
 * HTTP MIME type constants and utilities
 */
export const IMAGE_JPG_MIME = 'image/jpg';
/**
 * HTTP MIME type constants and utilities
 */
export const IMAGE_GIF_MIME = 'image/gif';
/**
 * HTTP MIME type constants and utilities
 */
export const HTML_MIME = 'text/html';
/**
 * HTTP MIME type constants and utilities
 */
export const TEXT_PLAIN_MIME = 'text/plain';
/**
 * HTTP MIME type constants and utilities
 */
export const TEXT_RTF_MIME = 'text/rtf';
/**
 * HTTP MIME type constants and utilities
 */
export const TEXT_URI_LIST_MIME = 'text/uri-list';
/**
 * HTTP MIME type constants and utilities
 */
export const VIDEO_MP4_MIME = 'video/mp4';
/**
 * HTTP MIME type constants and utilities
 */
export const VIDEO_X_YOUTUBE_MIME = 'video/x-youtube';
/**
 * HTTP MIME type constants and utilities
 */
export const ALL_AUDIO_MIME_TYPES = [
    AUDIO_MP3_MIME,
    AUDIO_MPEG_MIME,
    AUDIO_X_M4A_MIME,
];
/**
 * HTTP MIME type constants and utilities
 */
export const ALL_IMAGE_MIME_TYPES = [
    IMAGE_PNG_MIME,
    IMAGE_JPG_MIME,
    IMAGE_JPEG_MIME,
    IMAGE_GIF_MIME,
];
/**
 * HTTP MIME type constants and utilities
 */
export const ALL_VIDEO_MIME_TYPES = [VIDEO_MP4_MIME, VIDEO_X_YOUTUBE_MIME];
/**
 * HTTP MIME type constants and utilities
 */
export const ALL_COMPRESSION_MIME_TYPES = [COMPRESSED_MIME, RAR_MIME, ZIP_MIME];
/**
 * HTTP MIME type constants and utilities
 */
export const ALL_HTTP_MIME_TYPES = [
    ...ALL_AUDIO_MIME_TYPES,
    ...ALL_IMAGE_MIME_TYPES,
    ...ALL_VIDEO_MIME_TYPES,
    ...ALL_COMPRESSION_MIME_TYPES,
    JSON_MIME,
    MS_EXCEL_MIME,
    MS_POWERPOINT_MIME,
    MS_WORD_MIME,
    MS_XML_EXCEL_MIME,
    MS_XML_POWERPOINT_MIME,
    MS_XML_WORD_MIME,
    MULTIPART_FORM_DATA_MIME,
    RTF_MIME,
    TEXT_RTF_MIME,
    TEXT_URI_LIST_MIME,
    URLENCODED_MIME,
];
